import { render, staticRenderFns } from "./ProviderWrapper.vue?vue&type=template&id=dc164818"
import script from "./ProviderWrapper.vue?vue&type=script&lang=js"
export * from "./ProviderWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports